import React from "react";
import { Link } from "react-router-dom";
import Context from "../../../Context";
import EssenceActionsDropdown from "../../Essence/EssenceActionsDropdown";
import EssenceFiles from "../../Essence/EssenceFiles";
import EssenceStateLabel from "../../Essence/EssenceStateLabel";
import Blocker from "../../Misc/Blocker";
import DefaultNotFound from "../../Misc/DefaultNotFound";
import PropertyList from "../Property/PropertyList";
import ElementCritAlert from "./ElementCritAlert";
import ElementOperation from "./ElementOperation";

export default class ElementDetailDefault extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      item: {},
      parent: {},
      notFound: false,
      pending: false,
    };
  }

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.elementId !== this.props.elementId) {
      this.load();
    }
  }

  load = async () => {
    this.setState({ pending: true });
    let parent = {};
    let item = await this.context.api.q("/element/get", {
      id: this.props.elementId,
    });
    if (item?.parent) {
      parent = await this.context.api.q("/element/get", {
        id: item.parent,
      });
    }
    this.setState({
      pending: false,
      item,
      parent,
      notFound: !item,
    });
  };

  onMethodFinish = () => {
    if (this.props.onAfterSave) {
      this.props.onAfterSave(this.state.item);
    }
    this.load();
  };

  render() {
    const { pending, notFound, item, parent } = this.state;
    const { manageModel, shipId, specId, elementId } = this.props;
    return (
      <>
        <Blocker on={pending}>
          {notFound && <DefaultNotFound />}
          {item.id && (
            <>
              <div className="mt-5 d-flex justify-content-between">
                <div>
                  <div className="text-dark-50 small font-italic">
                    {item.shipname}
                  </div>
                  <div className="small">
                    <Link
                      to={`/element/${shipId}/${item.specification}/${elementId}/`}
                    >
                      {item.specificationname}
                    </Link>
                  </div>
                  <h5>{item.label}</h5>
                  <div>
                    <span className="text-muted mr-2">{item.modelname}</span>
                    {item.count > 1 && <span>{item.count} шт.</span>}
                  </div>
                </div>
                {manageModel && (
                  <div className="ml-3">
                    <div className=" d-flex justify-content-end align-items-center">
                      <Link
                        className="mr-4"
                        title={`Редактировать`}
                        to={`/element/${shipId}/${specId}/${elementId}/edit`}
                      >
                        <i className="fa fa-pencil text-hover-primary"></i>
                      </Link>
                      <Link
                        className="mr-3"
                        title={`Перейти к ЗИП ${item.modelname}`}
                        to={`/model/${item.category || "any"}/${item.model}/`}
                      >
                        <i className="fa fa-level-down text-hover-primary"></i>
                      </Link>
                      <EssenceStateLabel
                        stateCode={item.statetypecode}
                        stateLabel={item.statelabel}
                        essence="element"
                        id={item.id}
                      />
                      <EssenceActionsDropdown
                        essence={"element"}
                        key={item.id}
                        id={item.id}
                        label={item.label}
                        onFinish={this.onMethodFinish}
                      />
                    </div>
                  </div>
                )}
              </div>

              <div>
                <ElementCritAlert
                  critical={item.critical}
                  elementId={item.id}
                />
                {item.operating && (
                  <div className="my-2">
                    <ElementOperation brief {...this.props} />
                  </div>
                )}
              </div>

              {parent?.id && (
                <div className="row mt-2">
                  <div className="col-lg-6 my-2">Входит в:</div>
                  <div className="col-lg  my-2">
                    <Link
                      to={`/element/${parent.ship}/${parent.specification}/${parent.id}`}
                    >
                      {parent.label}
                    </Link>
                  </div>
                </div>
              )}

              <div className="row">
                <div className="col-lg-6 my-2">Заведование:</div>
                <div className="col-lg my-2">
                  {item.managerfullname || <span className=" ">Нет</span>}
                </div>
              </div>

              <div className="row">
                <div className="col-lg-6 my-2">Заводской номер:</div>
                <div className="col-lg my-2">{item.identity}</div>
              </div>

              <div className="row">
                <div className="col-lg-6  my-2">
                  Дата последнеднего кап. ремонта:
                </div>
                <div className="col-lg  my-2">
                  {item.overhaul
                    ? new Date(item.overhaul).toLocaleDateString()
                    : "Нет"}
                </div>
              </div>

              <div className="row">
                <div className="col-lg-6  my-2">Учитывать наработку:</div>
                <div className="col-lg  my-2">
                  {item.operating ? "Да" : "Нет"}
                </div>
              </div>

              <div className="row">
                <div className="col-lg-6  my-2">Критическое оборудование:</div>
                <div className="col-lg  my-2">
                  {item.critical ? "Да" : "Нет"}
                </div>
              </div>

              <div className="mt-5 pt-3">
                <PropertyList
                  title={<b>Свойства оборудования:</b>}
                  id={item.id}
                  reference="element"
                  referencekey="elementid"
                  hidePending
                />
              </div>
              <div className="mt-5">
                <PropertyList
                  title={
                    <b>
                      Свойства{" "}
                      <span className="text-muted">{item.modelname}</span>:
                    </b>
                  }
                  id={item.model}
                  reference="model"
                  referencekey="modelid"
                  hidePending
                />
              </div>

              <div className="mt-5">
                <EssenceFiles
                  listOnly
                  essence="model"
                  id={item.model}
                  key={item.model}
                />
              </div>
            </>
          )}
        </Blocker>
      </>
    );
  }
}
